import { ca } from '@cian/analytics';
import { IJsonQuery } from '../../types/jsonQuery/jsonQuery';

interface IPromoSearchClick {
  sc: IJsonQuery;
}

/**
 * Отправка события клика на поле с поиском в каталоге акций
 * https://conf.cian.tech/pages/viewpage.action?pageId=1311539818
 * @param {IPromoSearchClick} params - Параметры события
 */
export const trackPromoSearchClick = (params: IPromoSearchClick) => {
  const { sc } = params;

  ca('eventSite', {
    action: 'Click',
    category: 'Promo',
    label: 'Search',
    name: 'oldevent',
    sc,
  });
};
